module.exports = __webpack_public_path__ + "./images/c5b2d6003508815f9b888a90c54765b9.webp";